export default [
    {id:1,
      url: "Assets/star.svg",
      Heading:"FREE",
      p1:"Basic",
      p2:"Ads supported",
      p3:"Flexible workout planner",
      p4:"Top-notch log tracker",
      p5:"1400+ exercises library",
      p6:"Body stats tracking tools",
      p7:"Support interval training",
      btn:"FREE DOWNLOAD"
    },
    {id:2,
        url: "Assets/certificate.svg",
        Heading:"Elite Monthly",
        p1:"$12.99/month",
        p2:"All BASIC plan features",
        p3:"No ads",
        p4:"Comprehensive training reports",
        p5:"Advanced tracking features",
        p6:"Compare records with friends",
        p7:"Exercise tips from JEFIT experts",
        p8:"Premium workout plans",
        p9:"More...",
        btn:"LEARN MORE"
      },
      {id:3,
        url: "Assets/crown.svg",
        Heading:"Elite Yearly",
        p1:"$5.83/month",
        p2:"All BASIC plan features",
        p3:"No ads",
        p4:"Comprehensive training reports",
        p5:"Advanced tracking features",
        p6:"Compare records with friends",
        p7:"Exercise tips from JEFIT experts",
        p8:"Premium workout plans",
        p9:"More...",
        btn:"LEARN MORE"
      }
  ];